import { useFetcher, useRouteLoaderData } from 'react-router'
import { Button } from '#app/components/ui/button.tsx'
import { Icon } from '#app/components/ui/icon.tsx'
import { type loader as rootLoader } from '#app/root.tsx'

/**
 * Amber banner shown at the top of the page when an admin is impersonating an organization.
 * Includes the org name and a "Quitter" button to stop impersonation.
 *
 * Rendered in root layout, visible on all pages.
 */
export function ImpersonationBanner() {
	const rootData = useRouteLoaderData<typeof rootLoader>('root')

	if (!rootData?.isImpersonating) return null

	return <ImpersonationBannerContent orgName={rootData.impersonatingOrgName ?? undefined} />
}

function ImpersonationBannerContent({ orgName }: { orgName?: string }) {
	const fetcher = useFetcher()
	const isSubmitting = fetcher.state !== 'idle'
	const displayName = orgName ?? 'Organisation'

	return (
		<div className="sticky top-0 z-50 flex items-center justify-center gap-4 bg-amber-500 px-4 py-2.5 text-sm font-medium text-white shadow-md">
			<Icon name="magnifying-glass" className="h-4 w-4" />
			<span>
				Vous visualisez <strong>{displayName}</strong> en lecture seule
			</span>
			<fetcher.Form method="POST" action="/resources/admin/stop-impersonate">
				<Button
					type="submit"
					variant="outline"
					size="sm"
					className="border-white/30 bg-white/20 text-white hover:bg-white/30"
					disabled={isSubmitting}
				>
					{isSubmitting ? 'Fermeture...' : 'Quitter'}
				</Button>
			</fetcher.Form>
		</div>
	)
}
